/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpoListComponent} from './spo-list.component';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {StatusBarComponent} from '../../../shared/status-bar/status-bar.component';
import {RouterModule} from '@angular/router';
import {NgbCollapseModule, NgbDropdownModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MaterialListModule} from '../../../shared/material-list/material-list.module';
import {PaginationModule} from '../../../shared/pagination/pagination.module';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {StatusDotModule} from '../../../shared/status-dot/status-dot.module';
import {WarningsModule} from '../../../shared/warnings/warnings.module';
import {CodeFilterModule} from '../../../shared/filter/code-filter/code-filter.module';
import {DateFilterModule} from '../../../shared/filter/date-filter/date-filter.module';
import {InputAndCodeFilterModule} from '../../../shared/filter/input-and-code-filter/input-and-code-filter.module';
import {InputAndNumberFilterModule} from '../../../shared/filter/input-and-number-filter/input-and-number-filter.module';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';

@NgModule({ declarations: [
        SpoListComponent,
        StatusBarComponent
    ],
    exports: [SpoListComponent], imports: [CommonModule,
        RouterModule,
        NgbCollapseModule,
        MaterialListModule,
        PipesModule,
        RouterModule,
        NgbDropdownModule,
        PaginationModule,
        StatusDotModule,
        WarningsModule,
        CodeFilterModule,
        DateFilterModule,
        InputAndCodeFilterModule,
        InputAndNumberFilterModule,
        LoadingSpinnerModule,
        NgbModule,
        TooltipModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class SpoListModule {
}
